import React from 'react'
import { Link } from 'react-router-dom'
import './HomeQuickNav.css'

const LINKS = [
  { to: '#home-explorer', label: 'Territorios', icon: '⛩', sub: 'Hans del mundo' },
  { to: '/aventuras', label: 'Aventuras', icon: '⚔', sub: 'Misiones activas' },
  { to: '/clanes', label: 'Clanes', icon: '◎', sub: 'Alianzas y facciones' },
  { to: '/mapa', label: 'Mapa', icon: '◈', sub: 'Vista del mundo' },
]

export default function HomeQuickNav() {
  return (
    <nav className="home-quick-nav" aria-label="Accesos rápidos">
      <span className="home-quick-nav__label" aria-hidden="true">
        Tablón · 務
      </span>
      <div className="home-quick-nav__seals">
        {LINKS.map((item) => (
          <Link key={item.to} to={item.to} className="home-quick-nav__seal">
            <span className="home-quick-nav__seal-ring" aria-hidden="true" />
            <span className="home-quick-nav__seal-icon" aria-hidden="true">
              {item.icon}
            </span>
            <span className="home-quick-nav__seal-label">{item.label}</span>
            <span className="home-quick-nav__seal-sub">{item.sub}</span>
          </Link>
        ))}
      </div>
    </nav>
  )
}
